import http from "../http-common";
import { ITeamXProfitAndLossReportResponse, MemberBasedCustomerProfitLossReport } from "../types/TeamXReport";

const getTeamXProfitAndLossReport = (startDate: string, endDate: string) => {
  return http.get<ITeamXProfitAndLossReportResponse>(
    `report/team-x/profit-loss?startDate=${startDate}&endDate=${endDate}`
  );
};

const getTeamXCustomerBasedProfitLossReport = (startDate: string, endDate: string) => {
  return http.get<MemberBasedCustomerProfitLossReport[]>(
    `report/team-x/customer-based-profit-loss?startDate=${startDate}&endDate=${endDate}`
  );
};

const TeamXReportService = {
  getTeamXProfitAndLossReport,
  getTeamXCustomerBasedProfitLossReport,
};

export default TeamXReportService;
